<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
              <!-- <label for="date" style="width: 10%;"
               class="col-sm-1 control-label">Account</label>
              <div class="col-sm-2" >
                <Dropdown
                  v-model="account"
                  :options="accountMasterList"
                  optionLabel="name"
                  class="dropDown"
                  :filter=true
                  placeholder="Select Account"
                />
              </div> -->
         <div class="p-fluid p-formgrid p-grid">
           <div class="p-field p-col-12 p-md-2">
             <label for="fromDate">From Date</label>
             <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
             <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" class="nepali-calendar" id="toDate"  v-model="toDate"  v-else/>
          </div>

              <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="searchReversalBook" class="p-button p-component addNewBtn btn-btm-0" label="Search" icon="pi pi-search"/>
                <!-- <button type="submit" style="margin-left:10px"  @click.prevent="reset"
                 class="btn btn-info pull-left">Reset</button> -->
          </div>

          <div class="p-field p-col-12 p-md-7 p-mt-5">
          <a href="#" @click.prevent="exportCSV()" class="p-field p-col-12 p-md-12">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
          </div>
        </div>
        </form>
       <DataTable :value="receiptBookLists"
        :paginator="true" ref="po"
        :rows="100" :filters="filters"
        :rowsPerPageOptions="[100,500,1000]"
        class="p-datatable-responsive p-datatable-customers"
        data-key="id">
      <!-- <Column header="S.N" >
      </Column> -->
      <Column
       header="Miti" :sortable="true"
       field="transactionDateNepali"  filterMatchMode="contains" >
       <template #body="slotProps">
            {{!slotProps.data.repatedTransaction?slotProps.data.transactionDateNepali: ''}}
        </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']" />
        </template>
      </Column>
      <Column header="Date" :sortable="true" field="transactionDate"  filterMatchMode="contains">
      <template #body="slotProps">
            {{!slotProps.data.repatedTransaction?slotProps.data.transactionDate: ''}}
        </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']" />
        </template>
      </Column>
       <Column header="Vou Type" :sortable="true"  field="entryType"  filterMatchMode="contains">
        <template #body="slotProps">
            {{!slotProps.data.repatedTransaction?slotProps.data.entryType: ''}}
        </template>
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['entryType']" />
        </template>
      </Column>
      <Column header="Voucher" :sortable="true"  field="voucher"  filterMatchMode="contains">
        <template #body="slotProps">
            {{!slotProps.data.repatedTransaction?slotProps.data.voucher: ''}}
        </template>
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['voucher']" />
        </template>
      </Column>
      <Column header="Account" :sortable="true" field="accountName" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
        </template>
      </Column>
      <Column header="Narration"  field="remarks">
      <template #body="slotProps">
            {{!slotProps.data.repatedTransaction?slotProps.data.remarks: ''}}
        </template>
         <!-- <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['remarks']" />
        </template> -->
      </Column>
      <Column header="Debit" field="debitBalance"
       filterMatchMode="contains" bodyStyle="color:#00a65a;text-align: right">
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']" />
        </template>
      </Column>
      <Column header="Credit" field="creditBalance"
       filterMatchMode="contains"
      bodyStyle="color:#dd4b39;text-align: right" >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']" />
        </template>
      </Column>
      <!-- <Column header="closing Balance" field="closingBalance" filterField="closingBalance" filterMatchMode="contains" /> -->
      <template #empty>No record found</template>
      </DataTable>
      </div>
      <ReverseDialog ref="reverseDialogs"/>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteJournal"/>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Dialog from '../../layout/dialog'
import InputMask from 'primevue/inputmask'
import ReverseDialog from '../commonDialogs/reverseDialog.vue'
import Button from 'primevue/button'
export default {
  name: 'receiptBook',
  data() {
    return { name: '',
      fromDate: null,
      toDate: null,
      reversalBookList: [],
      account: '',
      accountMasterId: 0,
      loading: false,
      columnList: '',
      filters: {},
      type: 'reversal',
      dialogShow: false,
      receiptId: null,
      tranId: null,
      tranModuleType: null,
      englishDateEnabled: true
    }
  },
  computed: {
    receiptBookLists() {
      return this.$store.state.accountingReport.reversalBookLists
    }
  },
  mounted() {
    // this.accountList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchReversalBook() {
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let journal = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: this.accountMasterId,
        type: this.type
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadReversalBookList', journal)
      if (resp.data.data.length > 0) {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else if (resp.data.data.length === 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'No list available!', life: 10000})
      }
      this.loading = false
      this.reversalBookList = resp.data.data
    },
    openReverseTransaction(data) {
      this.$refs.reverseDialogs.openReverseDialog(data)
    },
    // async accountList() {
    //   await this.$store.dispatch('accountMasterList')
    // },
    openDialog(data) {
      this.dialogShow = true
      this.receiptId = data.id
      this.tranId = data.tranId
      this.tranModuleType = data.tranModuleType
    },
    closeDialog() {
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: this.accountMasterId,
        type: this.type
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/ReversalBook' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/' + data.type,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'reversalBook.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      this.reversalBookList = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Column,
    DataTable,
    InputText,
    Dialog,
    InputMask,
    ReverseDialog,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// reversalBook.vue?2417b42f